import './kitStyles';
/**
 * WEB-3310 юнит 1 — рисунки значков кита: набор `P` и мелкий набор `P_SM`
 * эталона `design/cabinet-rescin/kit.jsx` (спек-репо, origin/main 23.10.2026)
 * данными, без JSX. Значок — строка фигур через `|`:
 *   `<d>` — путь; `g:<d>` / `gd:<d>` — путь знака системного значка (класс g/gd);
 *   `c:cx,cy,r` — круг; `C:cx,cy,r` — круг, залитый цветом текста;
 *   `r:x,y,w,h,rx` — прямоугольник; `t:<transform>` — все фигуры значка
 *   в группе со сдвигом (только `ai`).
 * Рисует `Icon.tsx`; порядок имён — как в эталоне (`W2AKit.ICON_NAMES`).
 */
export const ICONS = {
  funnel: 'M4.6 4.5h14.8a.9.9 0 0 1 .7 1.5L14 13.4v5.2a.8.8 0 0 1-.5.7l-2.4 1a.6.6 0 0 1-.8-.6v-6.3L3.9 6a.9.9 0 0 1 .7-1.5z',
  ab: 'c:6.5,6,2.5|c:6.5,18,2.5|c:17.5,6,2.5|M6.5 8.5v7|M17.5 8.5c0 4.2-3 6.8-8.5 8',
  chart: 'M4 20h16|M7 16.5v-4|M12 16.5V7|M17 16.5v-7',
  mail: 'M5 5.5h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z|M3.6 7.2 12 12.8l8.4-5.6',
  user: 'M12 11.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5z|M4.75 20a7.25 7.25 0 0 1 14.5 0',
  users: 'M9.5 11a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5z|M3.5 19.5a6 6 0 0 1 12 0|M15.5 4.7a3.25 3.25 0 0 1 0 6.1|M17.8 13.7a6 6 0 0 1 2.7 5.8',
  pen: 'M14 6l4 4|M15.6 4.4a2 2 0 0 1 2.8 0l1.2 1.2a2 2 0 0 1 0 2.8L8.5 19.5 4 20.5l1-4.5z',
  lock: 'M6.5 11h11a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18.5v-6A1.5 1.5 0 0 1 6.5 11z|M8 11V8a4 4 0 0 1 8 0v3|M12 14.6v2',
  link: 'M10.2 13.8a3.6 3.6 0 0 0 5.1 0l3-3a3.6 3.6 0 0 0-5.1-5.1l-1.1 1.1|M13.8 10.2a3.6 3.6 0 0 0-5.1 0l-3 3a3.6 3.6 0 0 0 5.1 5.1l1.1-1.1',
  quiz: 'c:12,12,8.5|M9.6 9.4a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .8-1 1.5v.3|M12 16.5h.01',
  card: 'M5 6h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z|M3 10h18|M7 14.5h3.5',
  phone: 'M9.5 3h5A2.5 2.5 0 0 1 17 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 7 18.5v-13A2.5 2.5 0 0 1 9.5 3z|M11 18h2',
  globe: 'c:12,12,8.5|M3.5 12h17|M12 3.5c2.3 2.3 3.4 5.1 3.4 8.5s-1.1 6.2-3.4 8.5c-2.3-2.3-3.4-5.1-3.4-8.5S9.7 5.8 12 3.5z',
  store: 'M6.3 8h11.4l-.8 10.2a2 2 0 0 1-2 1.8H9.1a2 2 0 0 1-2-1.8z|M9 10V7.5a3 3 0 0 1 6 0V10',
  wallet: 'M18.5 8V6.5A2.5 2.5 0 0 0 16 4H6.5a2.5 2.5 0 0 0 0 5h12A1.5 1.5 0 0 1 20 10.5v8a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 4 17.5v-11|M16 14.5h.01',
  audit: 'M9 4.5H7.5A2.5 2.5 0 0 0 5 7v11a2.5 2.5 0 0 0 2.5 2.5h9A2.5 2.5 0 0 0 19 18V7a2.5 2.5 0 0 0-2.5-2.5H15|M10.2 3h3.6a1.2 1.2 0 0 1 1.2 1.2v.6a1.2 1.2 0 0 1-1.2 1.2h-3.6A1.2 1.2 0 0 1 9 4.8v-.6A1.2 1.2 0 0 1 10.2 3z|M9 11.5h6|M9 15.5h4',
  settings: 'M4 7.5h9|M17 7.5h3|c:15,7.5,2|M4 16.5h3|M11 16.5h9|c:9,16.5,2',
  sliders: 'M7.5 4v9|M7.5 17v3|c:7.5,15,2|M16.5 4v3|M16.5 11v9|c:16.5,9,2',
  search: 'c:11,11,6.5|m16 16 4 4',
  plus: 'M5.5 12h13|M12 5.5v13',
  minus: 'M5.5 12h13',
  download: 'M12 4v11|m7.5 10.5 4.5 4.5 4.5-4.5|M5 19.5h14',
  copy: 'M11 8.5h7a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 8.5 18v-7A2.5 2.5 0 0 1 11 8.5z|M15.5 5.5A2.5 2.5 0 0 0 13 3.5H6A2.5 2.5 0 0 0 3.5 6v7A2.5 2.5 0 0 0 5.5 15.5',
  trash: 'M4.5 7h15|M9.5 7V5.5A1.5 1.5 0 0 1 11 4h2a1.5 1.5 0 0 1 1.5 1.5V7|m6.5 7 .8 11.2a2 2 0 0 0 2 1.8h5.4a2 2 0 0 0 2-1.8L17.5 7',
  more: 'C:12,5.5,1|C:12,12,1|C:12,18.5,1',
  down: 'm7 10 5 5 5-5',
  check: 'm5.5 12.5 4 4 9-9.5',
  info: 'c:12,12,9|g:M12 16.4v-4.8|gd:M12 8.1h.01',
  warn: 'c:12,12,9|g:M12 7.6v4.8|gd:M12 16.1h.01',
  error: 'c:12,12,9|g:m9.2 9.2 5.6 5.6|g:m14.8 9.2-5.6 5.6',
  ok: 'c:12,12,9|g:m8.4 12.3 2.6 2.6 4.9-5.2',
  bolt: 'M13.2 3.5 6 13a.6.6 0 0 0 .5 1H11l-.7 6.2a.3.3 0 0 0 .5.2L18 11a.6.6 0 0 0-.5-1H13l.7-6.2a.3.3 0 0 0-.5-.3z',
  panel: 'M6 4h12a2.5 2.5 0 0 1 2.5 2.5v11A2.5 2.5 0 0 1 18 20H6a2.5 2.5 0 0 1-2.5-2.5v-11A2.5 2.5 0 0 1 6 4z|M9.5 4v16',
  stack: 'M6 4h12a2 2 0 0 1 2 2v2.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z|M6 13.5h12a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2.5a2 2 0 0 1 2-2z',
  building: 'M5 20V5.5A1.5 1.5 0 0 1 6.5 4h7A1.5 1.5 0 0 1 15 5.5V20|M15 9.5h2.5A1.5 1.5 0 0 1 19 11v9|M3.5 20h17|M8.5 8h3|M8.5 12h3|M8.5 16h3',
  shield: 'M12 3.5 5.5 6v5.3c0 4.1 2.7 7.4 6.5 8.9 3.8-1.5 6.5-4.8 6.5-8.9V6z|m9.3 12 1.9 1.9 3.6-3.8',
  key: 'c:8,16,4.5|M11.2 12.8 20 4|m15.5 8.5 2.5 2.5|m18 6 2.5 2.5',
  send: 'M20.5 3.5 3.5 10.3l6.6 2.6 2.6 6.6z',
  play: 'M5.5 5h13a2.5 2.5 0 0 1 2.5 2.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16.5v-9A2.5 2.5 0 0 1 5.5 5z|M10 9.2v5.6l4.8-2.8z',
  pin: 'M12 16.5V21|M8.5 4h7l-.8 5.5 3.3 3.5v1.5H6V13l3.3-3.5z',
  pinoff: 'M12 16.5V21|M8.5 4h7l-.8 5.5 3.3 3.5v1.5H6V13l3.3-3.5z|m4 4 16 16',
  locate: 'c:12,12,6.5|c:12,12,2.5|M12 2.5v3|M12 18.5v3|M2.5 12h3|M18.5 12h3',
  eye: 'M2.8 12S6.2 5.8 12 5.8 21.2 12 21.2 12 17.8 18.2 12 18.2 2.8 12 2.8 12z|c:12,12,2.8',
  eyeOff: 'M9.9 6a9.5 9.5 0 0 1 2.1-.2c5.8 0 9.2 6.2 9.2 6.2a15 15 0 0 1-2 2.7|M6.5 7.6A15 15 0 0 0 2.8 12s3.4 6.2 9.2 6.2a8.8 8.8 0 0 0 4.6-1.3|M10 10a2.8 2.8 0 0 0 4 4|m4 4 16 16',
  home: 'M4 10.2 12 4l8 6.2|M6 9v9.5A1.5 1.5 0 0 0 7.5 20h9a1.5 1.5 0 0 0 1.5-1.5V9|M10 20v-5h4v5',
  help: 'c:12,12,9|g:M9.5 9.5a2.6 2.6 0 1 1 3.6 2.4c-.7.3-1.1.8-1.1 1.5v.2|gd:M12 16.8h.01',
  up: 'm6.5 11 5.5-5.5 5.5 5.5|M12 18.5v-13',
  clip: 'm19 11.5-7.1 7.1a4.5 4.5 0 0 1-6.4-6.4l7.4-7.4a3 3 0 0 1 4.2 4.2l-7.3 7.3a1.5 1.5 0 0 1-2.1-2.1l6.6-6.6',
  dn: 'm17.5 13-5.5 5.5L6.5 13|M12 5.5v13',
  right: 'm10 7 5 5-5 5',
  left: 'm14 7-5 5 5 5',
  close: 'm6.5 6.5 11 11|m17.5 6.5-11 11',
  ai: 't:translate(-.15 2)|M10.5 4.5c.5 3.6 2.4 5.5 6 6-3.6.5-5.5 2.4-6 6-.5-3.6-2.4-5.5-6-6 3.6-.5 5.5-2.4 6-6z|M17.5 3.5c.2 1.4.9 2.1 2.3 2.3-1.4.2-2.1.9-2.3 2.3-.2-1.4-.9-2.1-2.3-2.3 1.4-.2 2.1-.9 2.3-2.3z',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.6L20 8.5|M20 4v4.5h-4.5',
  redo: 'm15 13.5 4.5-4.5L15 4.5|M19.5 9H9.5a5 5 0 0 0 0 10H13',
  undo: 'M9 13.5 4.5 9 9 4.5|M4.5 9h10a5 5 0 0 1 0 10H11',
  grid: 'r:4,4,6.5,6.5,2|r:13.5,4,6.5,6.5,2|r:4,13.5,6.5,6.5,2|r:13.5,13.5,6.5,6.5,2',
  clock: 'c:12,12,8.5|M12 7.5V12l3 2',
  // WEB-4172: дискета «Сохранить версию» (эталон kit.jsx, спек-репо eaf51d80)
  save: 'M6 4.5h10l3.5 3.5v10a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18V6A1.5 1.5 0 0 1 6 4.5z|M8 4.5v4h7v-4|M7.5 19.5v-5h9v5',
  map: 'M3.5 6.5 9 4l6 2.5L20.5 4v13.5L15 20l-6-2.5L3.5 20z|M9 4v13.5|M15 6.5V20',
} as const;

export type IconName = keyof typeof ICONS;

/** Имена значков в порядке эталона — для витрины. */
export const ICON_NAMES = Object.keys(ICONS) as IconName[];

/** Системные значки на размерах до 16: чистый контур и жирный знак. */
export const ICONS_SM: Partial<Record<IconName, string>> = {
  warn: 'c:12,12,8.5|g:M12 7.8v4.6|gd:M12 15.9h.01',
  error: 'c:12,12,8.5|g:m9.4 9.4 5.2 5.2|g:m14.6 9.4-5.2 5.2',
  ok: 'c:12,12,8.5|g:m8.6 12.3 2.4 2.4 4.5-4.8',
  info: 'c:12,12,8.5|g:M12 16.2v-4.6|gd:M12 8.1h.01',
  help: 'c:12,12,8.5|g:M9.7 9.6a2.4 2.4 0 1 1 3.3 2.2c-.6.3-1 .8-1 1.4v.2|gd:M12 16.6h.01',
};

export type IconShape =
  | { kind: 'path'; d: string; className?: 'g' | 'gd' }
  | { kind: 'circle'; cx: string; cy: string; r: string; fill?: 'currentColor' }
  | { kind: 'rect'; x: string; y: string; width: string; height: string; rx: string }
  | { kind: 'group'; transform: string };

/** Разбор строки значка в фигуры (формат — шапка файла). */
export function parseShapes(spec: string): IconShape[] {
  return spec.split('|').map((part): IconShape => {
    const m = /^([a-zA-Z]{1,2}):(.*)$/.exec(part);
    if (!m) return { kind: 'path', d: part };
    const [, tag, rest] = m;
    const n = rest.split(',');
    if (tag === 'g' || tag === 'gd') return { kind: 'path', d: rest, className: tag };
    if (tag === 'c') return { kind: 'circle', cx: n[0], cy: n[1], r: n[2] };
    if (tag === 'C')
      return { kind: 'circle', cx: n[0], cy: n[1], r: n[2], fill: 'currentColor' };
    if (tag === 'r')
      return { kind: 'rect', x: n[0], y: n[1], width: n[2], height: n[3], rx: n[4] };
    if (tag === 't') return { kind: 'group', transform: rest };
    throw new Error(`unknown icon shape: ${part}`);
  });
}
